import { apiClient } from "@/services/apiClient";
import type { WizardInstance, WizardTeamContext, SgSearchResult } from "@/types/workspace";

export async function startWizard(wizardType: string): Promise<{ instanceId: string; status: string }> {
  const res = await apiClient.post("/api/wizard/start", { wizardType });
  return res.data;
}

export async function getWizard(instanceId: string): Promise<WizardInstance> {
  const res = await apiClient.get<WizardInstance>(`/api/wizard/${instanceId}`);
  return res.data;
}

export async function advanceStep(instanceId: string, stepKey: string, data: Record<string, unknown>): Promise<{ currentStep: number; status: string }> {
  const res = await apiClient.post(`/api/wizard/${instanceId}/step`, {
    stepKey,
    dataJson: JSON.stringify(data),
  });
  return res.data;
}

export async function provisionWorkspace(instanceId: string): Promise<{ workspaceId: string }> {
  const res = await apiClient.post(`/api/wizard/${instanceId}/provision`);
  return res.data;
}

export async function getTeamContext(): Promise<WizardTeamContext> {
  const res = await apiClient.get<WizardTeamContext>("/api/wizard/team-context");
  return res.data;
}

export async function searchSecurityGroups(query: string): Promise<SgSearchResult[]> {
  const res = await apiClient.get<SgSearchResult[]>(`/api/wizard/search-sg?query=${encodeURIComponent(query)}`);
  return res.data;
}

export async function getMyWizardInstances(): Promise<WizardInstance[]> {
  const res = await apiClient.get<WizardInstance[]>("/api/wizard/my-instances");
  return res.data;
}
